import React from 'react';
import { Box, Container, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';

const ContactUs: React.FC = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const cardBg = useColorModeValue('white', 'gray.700');

  return (
    <Box bg={bgColor} py={20} minH="100vh">
      <Container maxW="container.lg">
        <Box bg={cardBg} p={10} borderRadius="lg" shadow="md">
          <Heading as="h1" size="2xl" mb={6} color={useColorModeValue('brand.700', 'brand.200')}>
            Contact Us
          </Heading>
          
          <VStack align="start" spacing={6}>
            <Text fontSize="lg" color="gray.600" lineHeight="tall">
              If you have questions about our Privacy Policy, Terms of Service, or just want to get in touch, contact us:
            </Text>

            <Box w="full">
              <Heading as="h2" size="xl" mb={4} color={useColorModeValue('brand.600', 'brand.200')}>
                MarketLink
              </Heading>
              <VStack align="start" spacing={3} pl={6} color="gray.600" fontSize="lg">
                <Text><strong>Email:</strong> Support@marketlink.co.zw</Text>
                <Text><strong>Phone:</strong> 0775 116 054 / 0783 006 221</Text>
                <Text><strong>Address:</strong> 5808 Hadzinamhanga Rd, Seke, Chitungwiza</Text>
              </VStack>
            </Box>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactUs;
